import React, { useState } from 'react';
import ListTemperatures from './ListTemperatures.js';
import AddTemperature from './AddTemperature.js';
import Upload from '../../shared/Upload.js';
import { ListButton, AddButton, UploadButton, DownloadButton, FAB } from '../../shared/ActionButtons';

export const Temperatures = ({ screen, setScreen, actions }) => {
  const [localScreen, setLocalScreen] = useState("list");

  // Use passed screen/setScreen if provided, otherwise use local state
  const currentScreen = screen !== undefined ? screen : localScreen;
  const setCurrentScreen = setScreen || setLocalScreen;

  return (
    <>
      {currentScreen === "list" && <ListTemperatures actions={actions}/>}
      {currentScreen === "list" && <FAB onClick={() => setCurrentScreen("add")} />}
      {currentScreen !== "list" && actions && <div className="content-header">{actions}</div>}
      {(currentScreen === "add") &&
        <AddTemperature
          onSuccess={() => setCurrentScreen("list")}
        />
      }
      {(currentScreen === "upload") &&
        <Upload collection="temperatures"
          onSuccess={() => setCurrentScreen("list")}
        />
      }
    </>
  );
}

// Action buttons component for use in hub header
export const TemperaturesActions = ({ screen, setScreen }) => (
  <div className="action-buttons">
    <ListButton
      isActive={screen === "list"}
      onClick={() => setScreen("list")}
    />
    <AddButton
      isActive={screen === "add"}
      onClick={() => setScreen("add")}
    />
    <UploadButton
      isActive={screen === "upload"}
      onClick={() => setScreen("upload")}
    />
    <DownloadButton collection="temperatures"/>
  </div>
);

export default Temperatures;
